module.exports = __webpack_public_path__ + "img/laboratorio_3-4_2304.56b47414.jpg";